import { render, staticRenderFns } from "./SimpleNewsList.vue?vue&type=template&id=74382e9c&"
import script from "./SimpleNewsList.vue?vue&type=script&lang=ts&"
export * from "./SimpleNewsList.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleNewsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports